module.exports = __webpack_public_path__ + "img/next.46aa301b.svg";